import { Form, Switch } from 'antd';
import classNames from 'classnames';
import type { ReactNode } from 'react';

import styles from './TextBlock.module.scss';

type TextBlockProps = {
  title: string;
  subtitle: string;
  switchName?: string[];
  hasBorder?: boolean;
  children?: ReactNode;
};

export const TextBlock = ({
  title,
  subtitle,
  switchName,
  hasBorder = false,
  children,
}: TextBlockProps) => {
  return (
    <div
      className={classNames(styles.container, {
        [styles.hasBorder]: hasBorder,
      })}
    >
      <div className={styles.header}>
        <div className={styles.textBlock}>
          <p className={styles.title}>{title}</p>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>
        {switchName && (
          <Form.Item name={switchName} valuePropName="checked" noStyle>
            <Switch />
          </Form.Item>
        )}
      </div>
      {children && <div className={styles.content}>{children}</div>}
    </div>
  );
};
